/**
 * Session endpoints, served from the app's own domain so their cookies are first-party.
 *
 * CloudFront routes `/api/v2/auth/*` on the app domain to API Gateway, and the local client's dev
 * server proxies the same prefix to the local API. The refresh cookie is scoped to `prefix`, so
 * the browser sends it to these endpoints and nowhere else.
 */
export const auth = {
	prefix: '/api/v2/auth',
	//
	token: '/token',
	refresh: '/refresh',
	logout: '/logout',
	/**
	 * One-time move of a session an older build kept in `localStorage` into the refresh cookie, so
	 * the switch to cookies signs nobody out. Remove once those sessions have expired (LON-370).
	 */
	handover: '/handover',
} as const;
